import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addLineItem: {
    description: 'editableOrderItems.addLineItem',
    defaultMessage: '+ Add a Line Item',
    id: 'JzCcZi',
  },
  itemHeaderSku: {
    description: 'editableOrderItems.itemHeaderSku',
    defaultMessage: 'SKU',
    id: 'wi49Gd',
  },
  itemHeaderName: {
    description: 'editableOrderItems.itemHeaderName',
    defaultMessage: 'Name',
    id: 'IDeZWO',
  },
  itemHeaderQuantity: {
    description: 'editableOrderItems.itemHeaderQuantity',
    defaultMessage: 'Quantity',
    id: 'UCSMpW',
  },
  itemHeaderPrice: {
    description: 'editableOrderItems.itemHeaderPrice',
    defaultMessage: 'Price',
    id: 'YWSbFN',
  },
});

export default messages;
